<div class="document-form">
  <div fxLayout="row">
    <div fxFlex="93">
      <h2>{{ 'GeneratingDocument' | translate }}</h2>
    </div>
    <div fxFlex="7">
      <button mat-icon-button color="primary" (click)="onClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div fxLayout="column" fxLayoutGap="10px">
    <form [formGroup]="formGroup">
      <div class="col-10">
        <app-agreement-picker [agreements]="agreements | async"
        (agreementSelectionChange)="onAgreementSelection($event)"></app-agreement-picker>
      </div>

      <mat-form-field appearance="outline" fxFill>
        <mat-label>{{ 'DocumentType' | translate }}</mat-label>
        <mat-select formControlName="documentTypeId">
          @for (documentType of listOfDocumentTypes$ | async; track documentType) {
            <mat-option #matOption [value]="documentType.Id">
              {{ documentType.Name }}
            </mat-option>
          }
        </mat-select>
        @if (documentTypeId.invalid && documentTypeId.touched) {
          <mat-error>
            {{ 'InvalidField' | translate }}
          </mat-error>
        }
      </mat-form-field>

      @if (isDocumentForm$ | async) {
        <div>
          <mat-form-field appearance="outline" fxFill>
            <mat-label>{{ 'DocumentPeriod' | translate }}</mat-label>
            <mat-select formControlName="documentPeriodId">
              @for (documentPeriod of listOfDocumentPeriods$ | async; track documentPeriod) {
                <mat-option #matOption
                  [value]="documentPeriod.Id">
                  {{ documentPeriod.Name }}
                </mat-option>
              }
            </mat-select>
            @if (documentPeriodId.invalid && documentPeriodId.touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }

      @if (isPaySlipForm$ | async) {
        <div>
          <mat-form-field appearance="outline" fxFill>
            <mat-label>{{ 'Year' | translate }}</mat-label>
            <mat-select formControlName="yearName">
              @for (year of listOfYears$ | async; track year) {
                <mat-option #matOption [value]="year.Name">
                  {{ year.Name }}
                </mat-option>
              }
            </mat-select>
            @if (yearName.invalid && yearName.touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" fxFill>
            <mat-label>{{ 'Month' | translate }}</mat-label>
            <mat-select formControlName="monthId">
              @for (month of listOfMonths$ | async; track month) {
                <mat-option #matOption [value]="month.Id">
                  {{ month.Name }}
                </mat-option>
              }
            </mat-select>
            @if (monthId.invalid && monthId.touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }

      @if (isDocumentForm$ | async) {
        <div>
          <mat-form-field appearance="outline" fxFill>
            <mat-label>{{ 'Description' | translate }}</mat-label>
            <textarea matInput formControlName="description" [maxLength]="maxDescriptionLength" cdkTextareaAutosize
            #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5"></textarea>
          </mat-form-field>
        </div>
      }
    </form>

    @if (isPaySlipForm$ | async) {
      <div>
        <alert message="TheAmountsOnThePaySlipMayBeChangedAfterAgreementCorrection" alertType="info"></alert>
        <alert message="ThePaySlipIsNotRequireSignatureOrStamp" alertType="info"></alert>
      </div>
    }

    <div class="header-wrapper"></div>

    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
      <button mat-raised-button (click)="onClose()">
        {{ 'Cancel' | translate }}
      </button>
      <div [matTooltip]="errorMessage$ | async | translate">
        <button mat-raised-button color="primary" (click)="onGenerate()" [disabled]="!!(errorMessage$ | async)">
          {{ 'Generate' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>